import { inject, Service } from '@angular/core';
import { concatMap, EMPTY } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

import { UserService } from '@user/repository';

@Service()
export class CustomEventService {
  private readonly userService: UserService = inject(UserService);

  public handleCustomEvent(itemRequestUrl: string): void {
    this.openSaml(itemRequestUrl);
  }

  private openSaml(urlPath: string): void {
    const tab = window.open('about:blank', '_blank');
    if (!tab) {
      return;
    }

    this.userService
      .setCookiesToCompany()
      .pipe(
        take(1),
        concatMap(() => {
          return this.userService.getRedirectionUrl(urlPath);
        }),
        catchError(() => {
          tab.close();
          return EMPTY;
        })
      )
      .subscribe((analyticExternalUrl) => tab.location.assign(analyticExternalUrl));
  }
}
